const release = "hh-senior-advisors.r120-heads-master-0-gc45ce70"

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}

module.exports = {
    release,
}
